<template>
    <v-card>
        <v-card-title class="subheading">
            Lookup
            <v-spacer />
            <v-icon @click="closeDialog()" small class="grey--text">fas fa-times</v-icon>
        </v-card-title>
        <v-card-text>
   
            <v-layout row wrap>
                <v-flex xs3>
                    <v-autocomplete
                        :items="dataSets"
                        class="style-input mr-2"
                        label="Lookups"
                        outline
                        single-line
                        height="15px"
                        return-object
                        item-text="name"
                        item-value="id"
                        v-model="dataSet"
                     />
                </v-flex>
                <v-flex xs3 pl-2>
                    <v-text-field
                        v-model="value.id"
                        outline
                        single-line
                        hide-details
                        height="15px"
                        label="Id"
                    />
                </v-flex>
                <v-flex xs3 pl-2>
                     <v-text-field
                        v-model="value.name"
                        outline
                        single-line
                        hide-details
                        height="15px"
                        label="Name"
                    />
                </v-flex>
                <v-flex xs1 class="pa-0 ma-0">
                    <v-btn style="zoom:90%" @click="closeDialog(value)" class="pa-2 ma-0 ml-2 blue white--text">Apply</v-btn>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
import DataSetModel from '@/api/service/DataSetService.js'

export default {
    props:["value"],
    data() {
        return {
            dataSets:[],
            dataSet:{}
        }
    },
    watch:{
        dataSet() {
            this.value.type='select'
            this.value.dataSet= this.dataSet.id
            this.value.id = this.dataSet.key_id
            this.value.name = this.dataSet.key_name
        }
    },
    created:function() {
        this.getDataSets()
    },
    methods: {
        closeDialog($value) {
            this.$emit('closeDialog',$value)
            //alert('clsoe')
        },
        async getDataSets() {
            try {
             this.dataSets = await DataSetModel.findAll({type:"D"})
            } catch(exception) {

            }
        },
    }
}
</script>